<template>
  <div class="jackisa">
    <h1>Jack & Isa</h1>
    <div>{{timeSince}}</div>
    <img :src="src" />
  </div>

</template>

<script>
export default {
  name: 'jackisa',
  data () {
    return {
      timeSince: '',
      src: require(`@/assets/Jack-Isa.jpg`)
    }
  },
  created () {
    // Enter the month, day, and year below you want to use as
    // the starting point for the date calculation
    var amonth = 12
    var aday = 31
    var ayear = 2020

    var x = new Date()
    var dyear
    var dmonth
    var dday
    var tyear = x.getFullYear()
    var tmonth = x.getMonth() + 1
    var tday = x.getDate()
    var y = 1
    var mm = 1
    var d = 1
    var a2 = 0
    var a1 = 0
    var f = 28

    if ((tyear / 4) - parseInt(tyear / 4) == 0) {
      f = 29
    }

    var m = new Array(31, f, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31)

    dyear = tyear - (ayear)

    dmonth = tmonth - amonth
    if (dmonth < 0) {
      dmonth = dmonth + 12
      dyear--
    }

    dday = tday - aday
    if (dday < 0) {
      var ma = amonth + tmonth
      if (ma > 12) { ma = ma - 12 }
      if (ma = 0) { ma = ma + 12 }
      dday = dday + m[ma]
      dmonth--
    }

    if (dyear == 0) { y = 0 }
    if (dmonth == 0) { mm = 0 }
    if (dday == 0) { d = 0 }
    if ((y == 1) && (mm == 1)) { a1 = 1 }
    if ((y == 1) && (d == 1)) { a1 = 1 }
    if ((mm == 1) && (d == 1)) { a2 = 1 }
    if (y == 1) {
      this.timeSince += +dyear + ' Years'
    }
    if ((a1 == 1) && (a2 == 0)) { this.timeSince += ' and ' }
    if ((a1 == 1) && (a2 == 1)) { this.timeSince += ', ' }
    if (mm == 1) {
      this.timeSince += dmonth + ' Months'
    }
    if (a2 == 1) { this.timeSince += ', and ' }
    if (d == 1) {
      this.timeSince += +dday + ' Days'
    }
  }
}

</script>

<style>
    .jackisa {
        text-align: center;
    }
    img {
        margin: 10px;
        max-width: 100%;
    }
</style>
